import { useQuery } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  getPromoData,
  type Params as GetPromoDataParams,
} from '@hungryroot/rest/api/get_promo_data/get';

export function usePromoData(params: GetPromoDataParams) {
  return useQuery({
    queryKey: ['promos'],
    queryFn: async () => {
      const req = await getPromoData(params);
      if (req.status !== StatusCode.SuccessOK) {
        throw req.data;
      }
      return req.data;
    },
  });
}
